import React from 'react'
import Terms from 'app/components/checkout/steps/partials/Terms'
const router = require('app/services/router')
const Trans = require('app/components/trans/Trans')
const env    = require("app/services/env")

export default class AlcoholTerms extends Terms {
  get type () {
    return translate('alkoholbetingelserne')
  }

  get urlToTerms () {
    return router.route('page.show', { pagePath: env.get('checkout.special_page_slugs.alcohol_policy', '') })
  }

  get checkboxId () {
    return 'termsOfAlcoholCheckbox'
  }

  renderLabelContents () {
    return (
      <>
        <Trans> Jeg er over 16 år <span className='hide-mobile'>- <a target='_blank' href={this.urlToTerms}>Hvorfor skal jeg være over 16?</a></span> </Trans>
      </>
    )
  }

  renderTerms () {
    return (
      <>
        <p>
          <Trans> Da vi på vores website kan sælge øl og vin, skal vi have dig til at bekræfte, at du er over 16 år. Hvis du er under 16 år, kan vi desværre ikke håndtere dit køb. <a href={this.urlToTerms} target='_blank'>Læs mere her</a> </Trans>
        </p>
      </>
    )
  }
}
